export function objectSize(object) {
    let size = 0, key;

    for (key in object) {
        if (object.hasOwnProperty(key)) size++;
    }

    return size;
}